import { Icon } from '@/lib/ui-kit/icons';

interface PriceAlertEmptyStateProps {
  message: string;
}

export function PriceAlertEmptyState({ message }: PriceAlertEmptyStateProps) {
  return (
    <div className="flex flex-col items-center gap-4 rounded-[10px] px-4 py-6">
      <Icon name="Search" size={20} className="text-v2-text-secondary" />
      <p className="body-xs max-w-[236px] whitespace-pre-line text-center text-v2-text-secondary">
        {message}
      </p>
    </div>
  );
}
